export default "__VITE_ASSET__5a24bc06__"